module.exports = __webpack_public_path__ + "img/waist.b786855b.png";